import './modal-template.scss';
import { useEffect, useRef, useState } from 'react';

export default function ModalTemplate(props) {

    const modalMainEl = useRef(null);
    const modalContentEl = useRef(null);

    const [render, setRender] = useState(false);
    
    useEffect(() => {
        if( props.isOpen) {
            setRender(true)
        } else {
            if(modalMainEl.current) {
                modalContentEl.current.classList.remove("animate__animated", "animate__fadeInUpBig", "animate__faster");
                modalContentEl.current.classList.add("animate__animated", "animate__fadeOutDownBig", "animate__faster");            
    
                modalContentEl.current.addEventListener('animationend', (event) => {
                    if(event.animationName === 'fadeOutDownBig') {
                        document.getElementsByTagName('body')[0].style.overflow =  'auto';
                        modalMainEl.current.style.display = 'none';
                        modalContentEl.current.style.display = 'none';
                        setRender(false)
                    }
                    
                }, { once: true });
            }
            
        }
    }, [props.isOpen]);
    
    useEffect(() => {

        if( render ) {
            document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            modalMainEl.current.style.display = 'block';

            setTimeout( () => {
                modalContentEl.current.style.display = 'block';
                modalContentEl.current.classList.remove("animate__animated", "animate__fadeOutDownBig", "animate__faster");
                modalContentEl.current.classList.add("animate__animated", "animate__fadeInUpBig", "animate__faster");
            })
        }
    }, [render]);

    return (
        <>
        { render && 
            <div className={ 'modal-template '+ props.className} style={{ display: 'none'}}  ref={modalMainEl}>
                <div className='modal-template-content ' style={{ display: 'none'}}  ref={modalContentEl}>
                    {props.children}
                </div>
            </div>
        }
        </>
    )
}